<template>
    <div>
        <public-title>移动推广
            <div slot="right" class="ml-auto">
                <el-button size="small" type="success" @click="editRoomTrends">发布房态</el-button>
                <span class="text-link ml-4 h6" v-show="isGroup" @click="$router.back()">返回列表</span>
            </div>
        </public-title>
        <div class="load-area">
            <el-tabs v-model="activeName">
                <el-tab-pane label="全部" name="all" />
                <el-tab-pane name="0">
                    <label slot="label">未推送<span class="unread-msg" v-show="unread > 0">{{unread}}</span></label>
                </el-tab-pane>
                <el-tab-pane name="1">
                    <label slot="label">已推送<span class="text-muted" v-show="alread > 0">({{alread}})</span></label>
                </el-tab-pane>
                <el-tab-pane name="2">
                    <label slot="label">已取消<span class="text-muted" v-show="caread > 0">({{caread}})</span></label>
                </el-tab-pane>
            </el-tabs>
            <div class="d-center-between mb-4 mt-4">
                <p class="d-center-start">
                    <left-text leftText="提交时间"/>
                    <el-date-picker class="ml-2" v-model="submittime" size="small" type="daterange"  range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期" />
                    <el-button type="primary" class="ml-5" size="small" @click="page=1;getRooms()">搜索</el-button>
                </p>
            </div>
            <el-table
            :data="tableData"
            style="width: 100%">
                <el-table-column prop="store_title" label="酒店名称" />
                <el-table-column prop="store_type" label="类型">
                    <template slot-scope="scope">
                        {{scope.row.roomstate_type == '2' ? '文字模式' : '表格模式'}}
                    </template> 
                </el-table-column>
                <el-table-column label="提交时间">
                    <template slot-scope="scope">
                        <div>{{scope.row.time | formatTimestamp(1)}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status == 0" class="text-danger">未推送</div>
                        <div v-if="scope.row.status == 1" class="text-blue">已推送</div>
                        <div v-if="scope.row.status == 2">已取消</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="text-link mr-3" v-if="scope.row.status == 0" @click="cancel(scope.row.store_id,scope.row.store_type,scope.row.id,scope.row.store_title)">取消</span>           
                        <span class="text-link mr-3" v-if="scope.row.status == 2" @click="$router.push({name:'addEditRM',query:{store_id: scope.row.store_id,store_type: scope.row.store_type, id: scope.row.id, store_title: scope.row.store_title, edit: 'edit',type: scope.row.roomstate_type}})">编辑</span>           
                        <span class="text-link" @click="goDetail(scope.row.store_id,scope.row.store_type,scope.row.id,scope.row.store_title)">查看</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next" class="mt-4"
                    v-show="total > 0" :page-size="10"
                     :total="total" :current-page=page
                     @current-change="v => this.page=v"/>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'PubRoomType',
    data () {
        return {
            submittime: [],
            tableData: [],
            activeName: 'all',
            total: 1,
            page: 1,
            status: '',
            unread: 0,
            alread: 0,
            caread: 0,
            showroom: true,
            Detail: {}
        }
    },
    computed: {
        ...mapGetters(['storeInfo','isGroup']),
        queryCon () { return this.$route.query }
    },
    created () {
        this.getRooms()
        this.getRooms1()
        this.getNums()
        if (!this.isGroup) this.getWaitHandleData()
    },
    watch: {
        activeName () {this.page = 1;this.submittime = []; this.getRooms()},
        'page': 'getRooms'
    },
    methods: {
        ...mapActions(['getWaitHandleData']),
        //添加、编辑促销活动
        editRoomTrends(item) {
            // if (!this.$GFUN.powerIsInArray([196,198])) { this._alert('您没有相关权限！',null,'error'); return; }
            if (!this.showroom) {this._alert('房态信息每天只能发布一次！')}
            else {
                let query = {storeId:this.queryCon.storeId,storeTitle:this.queryCon.storeTitle};
                // if (item) query.discount = item.id;
                this.$router.push({name:'addEditRM',query})
            }
        },
        //获取数据
        async getRooms () {
            let resData = await this.$axios.post('pc/Hotel/getRoomStateList', {
                    store_id: this.isGroup ? this.queryCon.storeId : this.storeInfo.storeId,
                    store_type: this.storeInfo.type,
                    status: this.activeName == 'all' ? '' : this.activeName,
                    page: this.page,
                    start_time: this.submittime.length > 0 ? Math.round(new Date(this.submittime[0]).getTime() / 1000) : '',
                    end_time: this.submittime.length > 0 ? Math.round((new Date(this.submittime[1]).getTime() + 24*60*60*1000 -1) / 1000) : '',
                    num: 10
                })
                if (resData.code === '00000' || resData.code === '99999') {
                    this.tableData = resData.info || []
                    this.total = resData.total_nums
                }
        },
        async getRooms1 () {
            let resData = await this.$axios.post('pc/Hotel/getRoomStateList', {
                    store_id: this.isGroup ? this.queryCon.storeId : this.storeInfo.storeId,
                    store_type: this.storeInfo.type,
                    status: this.activeName == 'all' ? '' : this.activeName,
                    page: this.page,
                    start_time: Math.round(new Date(new Date(new Date().toLocaleDateString()).getTime()) / 1000),
                    end_time: Math.round(new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1) / 1000),
                    num: 10
                })
                if (resData.code === '99999') {
                    this.showroom = true
                } else {
                    this.showroom = false
                }
        },
        //取消
        cancel (store_id,store_type,room_state_id,store_title) {
            this._confirm('确认取消么？',() => { this.confirmCancel(store_id,store_type,room_state_id,store_title) });
        },
        async confirmCancel (store_id,store_type,room_state_id,store_title) {
            let resData = await this.$axios.post('pc/Hotel/cancelRoomState', {
                store_id, store_type, room_state_id, store_title 
            })
            if (resData.code === '00000') {
                this.$message.success('已取消')
                this.getRooms()
                this.getNums()
                this.getWaitHandleData()
            }
        },
        goDetail (store_id,type,room_state_id,store_title,edit) {
            if (edit) this.$router.push({name:'RoomDetail',query:{store_id,type,room_state_id,store_title,edit}})
            else this.$router.push({name:'RoomDetail',query:{store_id,type,room_state_id,store_title}});
            sessionStorage.setItem('path', 'hotel')
        },
        //获取状态
        async getNums () {
            // let res = await this.$axios.post('pc/Hotel/getRoomStateStatus',{
            //     store_id: this.isGroup ? this.queryCon.storeId : this.storeInfo.storeId,
            //     store_type: this.storeInfo.type
            // })
            // if (res.code === '00000') {
            //     this.unread = res.info.status0
            //     this.alread = res.info.status1
            //     this.caread = res.info.status2
            // }
        }
    }
}
</script>

<style lang="scss" scoped>
.unread-msg {
    top: 0;
    left: 60px;
}
</style>
